import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccess, defaultLandingPath } from "@/lib/permissions";

export default function ProtectedRoute({ children, roles, permissionKey }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
        <div className="label-eyebrow">Načítám…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && roles.length && !roles.includes(user.role)) {
    return <Navigate to={defaultLandingPath(user)} replace />;
  }
  if (permissionKey && !canAccess(user, permissionKey)) {
    return <Navigate to={defaultLandingPath(user)} replace />;
  }
  return children;
}
